// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2qXFX","options":"AnswerScale_options__2BAo9","selected":"AnswerScale_selected__1Nzve"};